(function () {
  function videos(racine) {
    return racine.querySelectorAll('[data-vw-abo-video]');
  }

  function montrer(racine, cible) {
    var vues = racine.querySelectorAll('[data-vw-abo-vue]');
    for (var i = 0; i < vues.length; i++) vues[i].hidden = vues[i].getAttribute('data-vw-abo-vue') !== cible;
    var lecteurs = videos(racine);
    for (var k = 0; k < lecteurs.length; k++) {
      var v = lecteurs[k];
      var visible = !v.closest('[data-vw-abo-vue]').hidden;
      if (visible) {
        if (v.preload !== 'auto') v.preload = 'auto';
        var p = v.play && v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else if (v.pause) {
        v.pause();
      }
    }
    var vue = racine.querySelector('[data-vw-abo-vue="' + cible + '"]');
    if (vue && vue.querySelector('model-viewer') && window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !racine.getAttribute('data-vw-abo-3d')) {
      racine.setAttribute('data-vw-abo-3d', '1');
      window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function () {} }]);
    }
  }

  function precharger(vue) {
    var image = vue && vue.querySelector('img[loading="lazy"]');
    if (image) image.loading = 'eager';
  }

  function initialiser(racine) {
    var apercus = racine.querySelectorAll('[data-vw-abo-apercu]');
    for (var a = 0; a < apercus.length; a++) {
      var mv = apercus[a].querySelector('model-viewer');
      if (mv) mv.setAttribute('poster', apercus[a].getAttribute('data-vw-abo-apercu'));
    }
    var vues = racine.querySelectorAll('[data-vw-abo-vue]');
    var n = vues.length;
    var fleches = racine.querySelector('[data-vw-abo-fleches]');
    var position = racine.querySelector('[data-vw-abo-position]');
    if (fleches && n < 2) fleches.hidden = true;

    function courante() {
      for (var i = 0; i < n; i++) if (!vues[i].hidden) return i;
      return 0;
    }

    function aller(pas) {
      if (n < 2) return;
      var i = (courante() + pas + n) % n;
      montrer(racine, vues[i].getAttribute('data-vw-abo-vue'));
      if (position) position.textContent = 'Visuel ' + (i + 1) + ' sur ' + n;
      precharger(vues[(i + 1) % n]);
      precharger(vues[(i - 1 + n) % n]);
    }

    var boutons = racine.querySelectorAll('[data-vw-abo-pas]');
    for (var b = 0; b < boutons.length; b++) {
      boutons[b].addEventListener('click', function (e) {
        aller(Number(e.currentTarget.getAttribute('data-vw-abo-pas')));
      });
    }

    racine.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target.closest && e.target.closest('model-viewer')) return;
      e.preventDefault();
      aller(e.key === 'ArrowRight' ? 1 : -1);
    });

    var scene = racine.querySelector('[data-vw-abo-scene]');
    var depart = null;
    if (scene && n > 1) {
      scene.addEventListener('pointerdown', function (e) {
        depart = null;
        if (e.pointerType === 'mouse' || !e.isPrimary) return;
        if (e.target.closest && e.target.closest('model-viewer')) return;
        depart = { x: e.clientX, y: e.clientY };
      });
      scene.addEventListener('pointerup', function (e) {
        if (!depart) return;
        var dx = e.clientX - depart.x;
        var dy = e.clientY - depart.y;
        depart = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) aller(dx < 0 ? 1 : -1);
      });
      scene.addEventListener('pointercancel', function () {
        depart = null;
      });
    }

    var premiere = courante();
    if (n > 1) {
      precharger(vues[(premiere + 1) % n]);
      precharger(vues[(premiere - 1 + n) % n]);
    }
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (n && vues[premiere].querySelector('[data-vw-abo-video]') && !reduit) montrer(racine, vues[premiere].getAttribute('data-vw-abo-vue'));
  }

  function prix(racine) {
    var form = racine.querySelector('form[data-vw-abo-form]');
    if (!form) return;
    function maj() {
      var coche = form.querySelector('input[name="vw-abo-formule"]:checked:not([disabled])');
      var k = coche ? coche.getAttribute('data-k') : null;
      var etiquettes = form.querySelectorAll('[data-vw-abo-prix]');
      for (var i = 0; i < etiquettes.length; i++) etiquettes[i].hidden = !k || etiquettes[i].getAttribute('data-vw-abo-prix') !== k;
    }
    form.addEventListener('change', maj);
    form.addEventListener('click', function () { window.setTimeout(maj, 0); });
    maj();
  }

  function demarrer() {
    var racines = document.querySelectorAll('[data-vw-abonnement]');
    for (var i = 0; i < racines.length; i++) {
      var galerie = racines[i].querySelector('[data-vw-abo-galerie]');
      if (galerie) initialiser(galerie);
      prix(racines[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
